import { v2CartSelector } from '../constants';

export const isV2TopMenu = (): boolean => {
  return !!document.querySelector(v2CartSelector);
};
